/**
 * @module experience/shared-browse
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

/* tslint:disable max-file-line-count */
// Core Angular
import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { Wove } from 'aspect.js/';
import { ActivatedRoute } from '@angular/router';

// Interfaces and Models
import { DynamicModal } from '@support/shared/widgets/interfaces/dynamic-modal.interface';
import { LineSummary } from '@support/api/proxies/responses/api-2006.interface';

// Services
import { StateStoreUtilsService } from '@support/state-object-hash-utilities/utils/state-store-utils.service';

// contants
import { SHARED_BROWSE_COMPONENTS } from '@experience/shop/shared-browse/constants/shared-browse.constants';
import { ConfigData } from '@experience/repdash/interfaces/aem-content.interface';

@Wove({ moduleName: SHARED_BROWSE_COMPONENTS.SHARED_BROWSE_MODULE })
@Component({
  selector: 'tmo-upgrade-multiline-modal',
  templateUrl: './upgrade-multiline-modal.component.html',
  styleUrls: ['../../../../../../style-sheets/components/modal.component.scss'],
})
export class UpgradeMultilineModalComponent implements OnInit, OnDestroy {
  /**
   * Input. Stores Browse Plan AEM Data
   * @memberof DeviceErrorModalComponent
   */
  @Input() public aemContent: ConfigData;

  /** Event emitted when button is clicked
   * It emits the 'Event' boolean.
   */
  @Output() public onSelectUpgradeLine: EventEmitter<boolean>;

  /** Event emitted when cross is clicked
   * It emits the 'Event' boolean.
   */
  @Output() public closeMultilineUpgradeModal: EventEmitter<boolean>;

  /**
   * Stores the value to open modal
   */
  @Input() public displayModal: boolean;

  /**
   * Stores the line details
   */
  @Input() public lineDetails: LineSummary[];

  /**
   * Boolean holds spinner
   */
  public showSpinner: boolean;
  /**
   * Boolean holds line selection
   */
  public isLineSelected: boolean;
  /**
   * Dynamic Modal for prossible fraud detection
   */
  public upgradeMultilineModal: DynamicModal;
  /**
   * Subject to manage subscriptions
   */
  private ngUnsubscribe: Subject<void>;

  private lineOfServiceId: string;

  /**
   * Constructor function for static modal.
   */
  constructor(
    private stateStoreUtilsService: StateStoreUtilsService,
    public activatedRoute: ActivatedRoute
  ) {
    this.onSelectUpgradeLine = new EventEmitter<boolean>();
    this.closeMultilineUpgradeModal = new EventEmitter<boolean>();
    this.ngUnsubscribe = new Subject<void>();
    this.isLineSelected = false;
    this.upgradeMultilineModal = {
      disableDismiss: false,
      disableEsc: true,
      toggleModalEmitter: new EventEmitter<Object>(),
      dismissableMask: false,
      modalName: 'upgrade-multiline-modal',
    };
  }
  /**
   * this method is executed on load.
   * @returns void
   */
  public ngOnInit(): void {}

  /**
   * this method is executed when modal is closed.
   *  @returns void
   */
  public onUpgradeModalClose(): void {
    this.displayModal = false;
    this.closeMultilineUpgradeModal.emit(true);
  }

  /**
   *  function to set selected upgrade lineId
   *  @param value boolean
   *  @param lineOfServiceId string
   *  @returns void
   */
  public selectLine(value?: boolean, lineOfServiceId?: string): void {
    this.isLineSelected = value;
    this.lineOfServiceId = lineOfServiceId;
  }
  /**
   * Destroys existing subscriptions.
   * @returns void
   */
  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
  /**
   * this method is executed when modal gets closed.
   *  @returns void
   */
  public closeModal(): void {
    this.stateStoreUtilsService.setSelectedUpgradeLineId(this.lineOfServiceId);
    this.upgradeMultilineModal.toggleModalEmitter.emit({ open: false, close: true });
    this.displayModal = false;
    this.onSelectUpgradeLine.emit();
  }
}
